<template>
	<div class="msg-details-container">
		<div class="content-container">
			<!-- 面包屑导航 -->
			<div class="breadcrumb">
				<router-link to="/" class="breadcrumb-item">首页</router-link>
				<span class="breadcrumb-separator">></span>
				<router-link :to="{ path: '/msg-center', query: { category: 1 } }"
					class="breadcrumb-item">消息中心</router-link>
				<span class="breadcrumb-separator">></span>
				<span class="breadcrumb-item current">平台公告</span>
			</div>
			<div class="detailsBox">
				<div class="title">
					2025年终问卷调研中奖名单揭晓，快来看看有没有你!
				</div>
				<div class="time">
					2025-01-20 10:39:28
				</div>
				<div class="msgContent">
					2025年3月20日我们上线了抠图功能内测版，作为限时免费福利提供给大家使用。
					在我们技术人员半年左右的维护期间，抠图功能使用体验较为稳定。
					由于长期的维护成本，现内测结束，将暂时作为某些会员的赠送权益或单独购买，不再免费，望谅解！
					2025年3月20日我们上线了抠图功能内测版，作为限时免费福利提供给大家使用。
					在我们技术人员半年左右的维护期间，抠图功能使用体验较为稳定。由于长期的维护成本，
					现内测结束，将暂时作为某些会员的赠送权益或单独购买，不再免费，望谅解！
					2025年3月20日我们上线了抠图功能内测版，作为限时免费福利提供给大家使用。
					在我们技术人员半年左右的维护期间，抠图功能使用体验较为稳定。
					由于长期的维护成本，现内测结束，将暂时作为某些会员的赠送权益或单独购买，不再免费，望谅解！
					2025年3月20日我们上线了抠图功能内测版，作为限时免费福利提供给大家使用。
					在我们技术人员半年左右的维护期间，抠图功能使用体验较为稳定。由于长期的维护成本，
					现内测结束，将暂时作为某些会员的赠送权益或单独购买，不再免费，望谅解！
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MsgDetails',
		data() {
			return {

			}
		},
		methods: {

		}
	}
</script>

<style lang="scss" scoped>
	.msg-details-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	/* 面包屑导航样式 */
	.breadcrumb {
		margin-top: .32rem;
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
	}

	.breadcrumb-item {
		color: #000000;
		text-decoration: none;
		transition: color 0.3s ease;
	}

	.breadcrumb-item:hover {
		color: #000000;
	}

	.breadcrumb-item.current {
		color: #000000;
		font-weight: 500;
	}

	.breadcrumb-separator {
		margin: 0 0.02rem;
		color: #000000;
	}

	.detailsBox {
		margin: .24rem auto .8rem;
		padding: .32rem .4rem;
		width: 12rem;
		border-radius: .08rem;
		background: #FFFFFF;

		.title {
			font-weight: 500;
			font-size: .24rem;
			color: #252525;
		}

		.time {
			margin-top: .08rem;
			margin-bottom: .2rem;
			font-weight: 400;
			font-size: .14rem;
			color: #999999;
			line-height: .2rem;
			padding-bottom: .24rem;
			border-bottom: 0.01rem solid #CCCCCC;
		}

		.msgContent {
			font-weight: 400;
			font-size: .16rem;
			color: #252525;
		}
	}
</style>